import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, FileText, BarChart3, FileSpreadsheet } from 'lucide-react';

const AgentBottomNav = ({ active = null }) => {
	const navigate = useNavigate();
	const itemClass = (isActive) =>
		`flex flex-col items-center gap-1 p-2 rounded-xl ${isActive ? 'bg-[#001E3C]' : ''}`;
	const iconClass = (isActive) =>
		`w-5 h-5 ${isActive ? 'text-[#00F5FF]' : 'text-white/60'}`;

	return (
		<nav className='p-4 border-t border-white/10 bg-[#000B18]'>
			<div className='grid gap-1 grid-cols-4'>
				<button
					type='button'
					onClick={(e) => {
						e.preventDefault();
						navigate('/agent/dashboard');
					}}
					className={itemClass(active === 'data-collection')}>
					<Home className={iconClass(active === 'data-collection')} />
					<span className='text-[9px] font-bold uppercase text-white leading-none text-center'>
						Dashboard
					</span>
				</button>
				<button
					type='button'
					onClick={(e) => {
						e.preventDefault();
						navigate('/agent/deliver-bills');
					}}
					className={itemClass(active === 'bills')}>
					<FileText className={iconClass(active === 'bills')} />
					<span className='text-[10px] font-bold uppercase text-white'>Bills</span>
				</button>
				<button
					type='button'
					onClick={(e) => {
						e.preventDefault();
						navigate('/agent/reports');
					}}
					className={itemClass(active === 'reports')}>
					<FileSpreadsheet className={iconClass(active === 'reports')} />
					<span className='text-[9px] font-bold uppercase text-white leading-none'>Reports</span>
				</button>
				<button
					type='button'
					onClick={(e) => {
						e.preventDefault();
						navigate('/agent/performance');
					}}
					className={itemClass(active === 'performance')}>
					<BarChart3 className={iconClass(active === 'performance')} />
					<span className='text-[9px] font-bold uppercase text-white leading-none'>
						Perf.
					</span>
				</button>
			</div>
		</nav>
	);
};

export default AgentBottomNav;
